import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import InputField from '../../../components/form/InputField';
import FormGroup from '../../../components/form/FormGroup';
import {
  createArtisanTagAction,
  updateArtisanTagAction,
  getArtisanTagsAction
} from '../../../modules/artisanTags/Actions';
import {
  artisanTagsIsLoadingSelector,
  artisanTagByIdSelector
} from '../../../modules/artisanTags/Selectors';
import FormBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';

import * as Yup from 'yup';
import { getArtisans } from '../../../modules/artisans/Api';
import getLangData from '../../../utils/getLangData';

const schema = () =>
  Yup.object().shape({
    name: Yup.string()
      .required(getLangData().fields.required)
      .default(''),
    namei18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default('')
    })
  });

const ArtisanTagsForm = props => {
  const {
    tagId,
    isLoading,
    createArtisanTag,
    updateArtisanTag,
    getArtisanTags,
    artisanTag
  } = props;

  useEffect(() => {
    if (tagId && !artisanTag) {
      getArtisanTags();
    }
  }, [getArtisanTags, tagId, artisanTag]);
  const profileLang = getLangData().profile_types;
  const fieldsLang = getLangData().fields;
  const buttonsLang = getLangData().buttons;
  return (
    <Formik
      initialValues={artisanTag ? { ...artisanTag } : schema().cast()}
      validationSchema={schema()}
      onSubmit={async values => {
        const data = {
          name: values.name,
          tagImage: values.tagImage,
          namei18n: values.namei18n
        };
        if (tagId) {
          await updateArtisanTag(tagId, data);
        } else {
          await createArtisanTag(values);
        }
      }}
    >
      {({ handleSubmit, errors }) => (
        <FormGroup
          errors={errors}
          isLoading={isLoading}
          handleSubmit={handleSubmit}
          heading={
            artisanTag
              ? `${buttonsLang.update} [${artisanTag.name}]`
              : buttonsLang.create
          }
        >
          <InputField label={fieldsLang.name} name='name' />
          <FormBIOi18n name='namei18n' description={fieldsLang.name} />
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const tagId = props.match.params.id;
  return {
    tagId,
    isLoading: artisanTagsIsLoadingSelector(state),
    artisanTag: artisanTagByIdSelector(state, tagId)
  };
};

export default connect(mapStateToProps, {
  getArtisanTags: getArtisanTagsAction,
  createArtisanTag: createArtisanTagAction,
  updateArtisanTag: updateArtisanTagAction
})(ArtisanTagsForm);
